module.exports = __webpack_public_path__ + "img/part2.8e6b8ad2.jpeg";